export const REASONS_GROUPS = ['audio', 'video', 'sharing'] as const;

export const REASONS: {
    [GroupKey in (typeof REASONS_GROUPS)[number]]: ReadonlyArray<`${GroupKey}_${string}`>;
} = {
    audio: ['audio_distorted', 'audio_desync', 'audio_noise', 'audio_volume', 'audio_echo', 'audio_no-data'],
    video: ['video_distorted', 'video_freezing', 'video_no-data'],
    sharing: ['sharing_distorted', 'sharing_no-data'],
} as const;

export type ReasonsGroup = (typeof REASONS_GROUPS)[number];

export type Reason = (typeof REASONS)[ReasonsGroup][number];
